const CALISTA_ADVISORY_FTA_MAPPING_URL = `${process.env.REACT_APP_CALISTA_ADVISORY_URL}/cal-cia/cia-admin/fta-mapping`

const CIAFtaMappingApiUrls = {
    GET: `${CALISTA_ADVISORY_FTA_MAPPING_URL}/get`,
    POST: `${CALISTA_ADVISORY_FTA_MAPPING_URL}/create`,
    PUT: `${CALISTA_ADVISORY_FTA_MAPPING_URL}/update`,
    DELETE: `${CALISTA_ADVISORY_FTA_MAPPING_URL}/delete`
}

export default CIAFtaMappingApiUrls
